import React from 'react';
import { useTranslation } from 'react-i18next';
import { SpinSize } from 'antd-v5/lib/spin';
import { Spin } from 'UI';
import { LoaderWrapper } from './Loader.styled';

export interface LoaderProps {
  size?: SpinSize;
  height?: string;
  withLabel?: boolean;
}

const Loader = ({ size = 'large', height = '100vh', withLabel = false }: LoaderProps) => {
  const { t } = useTranslation();
  return (
    <LoaderWrapper height={height}>
      <Spin size={size} dataCy={'loader-spinner'} />
      {withLabel && t('common.action.loading', 'Loading ...')}
    </LoaderWrapper>
  );
};

export default Loader;
